<script>
import { cn } from "$lib/utils";

let { class: klass, ...rest } = $props();

const _class = $derived(cn("size-4", "shrink-0", klass));
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="1.4"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={_class}
  aria-label="File Question icon"
  {...rest}
  ><path d="M12 17h.01"></path><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"></path><path
    d="M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3"
  ></path></svg
>
